import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

import {
    CreateAndEditCountryModalProps
} from "./models";

import { t, Trans } from "@lingui/macro";
import * as Yup from "yup";
import { withUseFormHook, } from "@sinossi/mates-react-library";
import {ContentProducerService} from "services/content-producer-service";
import { ZPlayFormField } from "commons/fields";
import { CreateCountryRequest, EditCountryRequest } from "models/request";

const CreateAndEditCountryModalSchema = Yup.object().shape({
    name: Yup.string().required(t({
        id: "caectm-name-required-msg",
        message: "È necessario inserire un nome per poter modificare il paese"
    })),
});

class CreateAndEditCountryModal extends React.Component<CreateAndEditCountryModalProps & UseFormReturn, {}>
{
    componentDidMount(){
        if(this.props.country){
            this.props.setValue("name", this.props.country.value);
        }
    }

    private getValues = () => {
        let value = this.props.getValues("name")
        if(this.props.country){
            this.editCountry(value);
        } else {
            this.createCountry(value);
        }
    }

    private editCountry = (values: any) => {

        let request: EditCountryRequest = {
            value: values
        }

        ContentProducerService.editCountry(this.props.country!.id, request, this.props.editCountryCallback, this.props.editCountryErrorCallback)
    }

    private createCountry = (values: any) => {

        let request: CreateCountryRequest = {
            value: values
        }

        ContentProducerService.createCountry(request, this.props.createCountryCallback, this.props.createCountryErrorCallback);
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={() => this.props.closeModal()}
                color={process.env.REACT_APP_BACKGROUND_COLOR}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    {this.props.country? <Trans id="caectm-edit-title">Modifica paese</Trans> : <Trans id="caectm-create-title">Aggiungi paese</Trans>}
                </DialogTitle>
                <form>
                    <DialogContent>
                        <Typography mt={-2}>
                            <Trans id="caectm-country-name-label">Inserisci un paese</Trans>
                        </Typography>
                        <ZPlayFormField
                            label={t({
                                id: "caectm-name",
                                message: "Paese"
                            })}
                            name="name"
                            required={true}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={this.props.closeModal}>
                            <Trans id={"caectm-close-btn"}>
                                Annulla
                            </Trans>
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            type="button"
                            onClick={this.getValues}
                            disabled={this.props.formState.isSubmitting}>
                            {this.props.country? <Trans id="caectm-edit-btn">Modifica</Trans> : <Trans id="caectm-create-btn">Aggiungi</Trans>}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

export default withUseFormHook<{}>(CreateAndEditCountryModal, CreateAndEditCountryModalSchema, {});
